var _circle, _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect3, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _rect4, _circle8, _circle9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOrgChartIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#EBEBF9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 8,
    width: 24,
    height: 8,
    rx: 2,
    fill: "#3030AD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 56,
    width: 24,
    height: 8,
    rx: 2,
    fill: "#3030AD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 16L23 33",
    stroke: "#AFAFE9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 64L27 77",
    stroke: "#AFAFE9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 56L56 40",
    stroke: "#AFAFE9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 59L24 40",
    stroke: "#AFAFE9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75 59L56 40",
    stroke: "#AFAFE9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40 16L57 33",
    stroke: "#AFAFE9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40 64L53 77",
    stroke: "#AFAFE9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40 56L24 40",
    stroke: "#AFAFE9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 32,
    width: 24,
    height: 8,
    rx: 2,
    fill: "#3030AD"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 16,
    r: 2,
    fill: "#3030AD"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 16,
    r: 1,
    fill: "#AFAFE9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 64,
    r: 2,
    fill: "#3030AD"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 40,
    r: 2,
    fill: "#3030AD"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 40,
    r: 1,
    fill: "#AFAFE9"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 64,
    r: 1,
    fill: "#AFAFE9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 32,
    width: 24,
    height: 8,
    rx: 2,
    fill: "#3030AD"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 40,
    r: 2,
    fill: "#3030AD"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 40,
    r: 1,
    fill: "#AFAFE9"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOrgChartIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/orgChartIcon.98894444ded20d8c7b4a58cd5cb459a1.svg";